import {Alert} from '@mui/material';
import {useZeroNeetAuth} from '../utils/useZeroNeetAuth';
import Dashboard3 from '../Dashboard3';

// "I nostri modelli di collaborazione" page — Dashboard 3.
const ZeroNeetCollaboration = () => {
    const {container, uoaId, surveyIds, isAuthorized} = useZeroNeetAuth(['survey5_id']);

    if (!isAuthorized) {
        return <Alert severity='error'>Parametri mancanti o chiave non valida.</Alert>;
    }

    return <Dashboard3 container={container!} uoaId={uoaId!} survey504Id={surveyIds.survey5_id!} />;
};

export default ZeroNeetCollaboration;
